import React, { useState, useEffect } from 'react';
import { getCaCsBankDetails, updateCaCsBankDetails } from '../../../controller/agent_data_controller';

export const ManageBankDetailsCACS = () => {
    const [bankName, setBankName] = useState('');
    const [accountName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [upiId, setUpiId] = useState('');
    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        const fetchDetails = async () => {
            setLoading(true);
            const data = await getCaCsBankDetails();
            if (data) {
                setBankName(data.bankName || '');
                setAccountName(data.accountName || '');
                setAccountNumber(data.accountNumber || '');
                setIfscCode(data.ifscCode || '');
                setUpiId(data.upiId || '');
            }
            setLoading(false);
        };
        fetchDetails();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setUpdating(true);
        const result = await updateCaCsBankDetails(bankName, accountName, accountNumber, ifscCode, upiId);
        if (result === 'success') {
            alert('Bank details updated successfully');
        } else {
            alert('Failed to update bank details: ' + result);
        }
        setUpdating(false);
    };

    if (loading) return <div style={{ padding: '30px' }}>Loading bank details...</div>;

    return (
        <div style={{ padding: '30px' }}>
            <h2 className="services-title">Manage Bank Details</h2>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                maxWidth: '600px'
            }}>
                <p style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                    Provide your bank details here. These details will be required for the Admin to process payments for completed work.
                </p>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Bank Name:</label>
                        <input
                            type="text"
                            value={bankName}
                            onChange={(e) => setBankName(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Account Name:</label>
                        <input
                            type="text"
                            value={accountName}
                            onChange={(e) => setAccountName(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Account Number:</label>
                        <input
                            type="text"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>IFSC Code:</label>
                        <input
                            type="text"
                            value={ifscCode}
                            onChange={(e) => setIfscCode(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '25px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>UPI ID (Optional):</label>
                        <input
                            type="text"
                            value={upiId}
                            onChange={(e) => setUpiId(e.target.value)}
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={updating}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#3765A5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: updating ? 'not-allowed' : 'pointer',
                            fontSize: '16px',
                            fontWeight: '500'
                        }}
                    >
                        {updating ? 'Saving...' : 'Save Bank Details'}
                    </button>
                </form>
            </div>
        </div>
    );
};
